import { FeaturePermissionMatrix } from '@/apis/types';

export interface FeatureItem {
  feature_name: string;
  permission: PermissionValue[];
}

export interface SubFeatureItem extends FeatureItem {
  description?: string;
  allowed_statuses?: string[];
}

export interface RoleModel {
  id: string;
  name: string;
  is_connected_with_anything?: boolean;
  feature_list?: FeatureItem[];
  sub_feature_list?: SubFeatureItem[];
}
export type PermissionValue =
  'VIEW' | 'EDIT' | 'CREATE' | 'NO_ACCESS' | 'Create_self' | string;

export interface FeatureItem {
  feature_name: string;
  permission: PermissionValue[];
}

export interface SubFeatureItem extends FeatureItem {
  description?: string;
  allowed_statuses?: string[];
}

export interface RoleModel {
  id: string;
  name: string;
  is_connected_with_anything?: boolean;
  feature_list?: FeatureItem[];
  sub_feature_list?: SubFeatureItem[];
}

export interface MenuState {
  items: Record<string, unknown>;
}

export interface RootState {
  menu: MenuState;
}
export const UI_STATUSES = [
  'Awaiting pickup',
  'Pending',
  'In transit',
  'Delivery exception',
  'Delivered',
  'Not found',
] as const;

export const API_STATUSES = [
  'Awaiting Pickup',
  'PENDING',
  'IN-TRANSIT',
  'DELIVERY_EXCEPTION',
  'DELIVERED',
  'Not Found',
] as const;

export function toPermissionMatrix(perms: unknown): FeaturePermissionMatrix {
  const base: FeaturePermissionMatrix = {
    is_create: false,
    is_update: false,
    is_delete: false,
    is_view: false,
    create_self: false,
    edit_contacts_only: false,
  };

  if (!Array.isArray(perms)) {
    return { ...base, ...(perms as Partial<FeaturePermissionMatrix>) };
  }

  const p = perms as PermissionValue[];

  return {
    is_create: p.includes('CREATE'),
    is_update: p.includes('EDIT'),
    is_view: p.includes('VIEW'),
    is_delete: p.includes('DELETE' as PermissionValue),
    create_self: p.includes('Create_self'),
    edit_contacts_only: p.includes('EDIT_CONTACTS_ONLY'),
  };
}

export interface ApiEnvelope<T> {
  data: {
    is_success: boolean;
    data: T;
    message?: string;
  };
}

export interface HttpResponse<T> {
  data: T;
}

export interface EditRoleFormData {
  id: string;
  name: string;
  is_connected_with_anything?: boolean;
  is_delete?: boolean;
}
export interface SectionsRow {
  key: string;
  feature_name: string;
  [roleId: string]: PermissionValue | string;
}
export interface FeaturesRow {
  key: string;
  feature_name: string;
  description?: string;
  allowedMap: Record<string, string[]>;
}
export interface RefreshTokenData {
  access: string;
  refresh: string;
}

export interface RefreshTokenPayload {
  data: RefreshTokenData;
  is_success: boolean;
  message: string;
  messageTypeId: string;
  page_count: number;
  status: number;
}

export interface RefreshTokenResponse {
  data: RefreshTokenPayload;
  message: {
    messageTypeId: string;
    text: string;
    title: string;
  };
}
